export default {
    shouldMockAngular() {
        return !!(window as any).PHWEB2?.mockAngularLayer;
    }
}
